import { Body1, Button, Subtitle2, Divider, mergeClasses } from "@fluentui/react-components";
import React from "react";
import { useStyles } from "./useStyles";

type CartEntryProps = {
  amount?: string;
  cafeId?: string;
  itemId?: string;
  label?: string;
  accessibleLabel?: string;
  subTitle?: string;
  customInstructions?: string;
  divStatus?: boolean;
  amountClassName?: string;
  id?: string;
  totalAmountClassName?: string;
  onRemove?: (cafeId: string, itemId: string) => void;
  onEdit?: (cafeId: string, itemId: string, id: string) => void;
  removeButtonRef?: React.RefObject<HTMLButtonElement>;
};

export const CartEntry = ({
  amount,
  cafeId,
  itemId,
  label,
  accessibleLabel,
  subTitle,
  customInstructions,
  divStatus,
  amountClassName,
  totalAmountClassName,
  id,
  onRemove,
  onEdit,
  removeButtonRef,
}: CartEntryProps) => {
  const styles = useStyles();
  const ariaBaseLabel = accessibleLabel ?? label ?? "Item";
  return (
    <>
      <div className={styles.container} data-testid="CartEntry">
        <div className={styles.info}>
          <Subtitle2 wrap truncate className={totalAmountClassName}>
            <span aria-hidden={accessibleLabel && accessibleLabel !== label ? "true" : undefined}>
              {label}
            </span>
            {accessibleLabel && accessibleLabel !== label && (
              <span className={styles.visuallyHidden}>{accessibleLabel}</span>
            )}
          </Subtitle2>
          <Body1 className={styles.subTitle} wrap truncate>
            {subTitle}
          </Body1>
          <Body1 className={styles.customInstructions}>{customInstructions}</Body1>
          <div className={styles.buttonsContainer}>
            {onRemove && cafeId && id && (
              <Button
                aria-label={`${ariaBaseLabel} Remove Item`}
                appearance="transparent"
                className={styles.removeButton}
                onClick={() => onRemove(cafeId, id)}
                data-testid="removeItemBtn"
                tabIndex={8}
                ref={removeButtonRef}
              >
                Remove
              </Button>
            )}
            {onEdit && cafeId && itemId && id && (
              <Button
                aria-label={`${ariaBaseLabel} Edit Item`}
                appearance="transparent"
                className={styles.editButton}
                onClick={() => onEdit(cafeId, itemId, id)}
                data-testid="editItemBtn"
                tabIndex={7}
              >
                Edit
              </Button>
            )}
          </div>
        </div>

        <Subtitle2 className={mergeClasses(amountClassName, totalAmountClassName)}>
          {amount}
        </Subtitle2>
      </div>
      {divStatus && <Divider />}
    </>
  );
};
